import React, { useEffect, useRef, useState } from 'react';
import './styles.css';

import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faComment,
  faThumbsUp,
  faShare,
  faPaperPlane,
  faGlobeAmericas,
  faEllipsis
} from '@fortawesome/free-solid-svg-icons';
import Image from 'react-bootstrap/Image';
import VideoComponent from './VideoComponent';
import { useTranslate } from '@tolgee/react';
import PdfComponent from './PdfComponent';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';
import { useSelector, useDispatch } from 'react-redux';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { COMPACT_MODE_HEIGHT } from '../contants';
import LinkPreview from './linkPreviewComponent';
import { LINKEDIN_BUSINESS_PAGE } from '../../../../config/constants';
import PreviewImagesSkeleton from '../loaders/previewImagesSkeleton';
import OnImagesLoaded from '../../../onImagesLoaded';
import PlatformIconSkeleton from '../loaders/platformIconSkeleton';
import ImportedPostsMediaPreview from './importedPostsMediaPreview';
import AltTagButton from './buttons/altTagsBtn';

export default function LinkedinPostPreview({
  platform = LINKEDIN_BUSINESS_PAGE,
  cropList = null,
  mediaFiles = null,
  postText = null,
  profileName = null,
  platformIcon = null,
  previewAssets,
  viewAssets,
  previewUrl = null
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [imageStyles, setImageStyles] = useState({});
  const [containerHeight, setContainerHeight] = useState('250px');
  const {
    ui: { previewMode },
    created_in_lomavis
  } = useSelector((state: any) => state.lomavisCreator);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  useEffect(() => {
    if (mediaFiles && cropList) {
      const styles = {};
      let height = 0;

      if (mediaFiles.length === 1) {
        const ratio = mediaFiles[0].height / mediaFiles[0].width;
        height = containerWidth * ratio;
        styles[0] = { inset: '0', height: '100%' };
        setContainerHeight(`${height}px`);
      } else if (mediaFiles.length === 2) {
        height = 388;
        styles[0] = { inset: '0 calc(50% + 1.01px) 0 0' };
        styles[1] = { inset: '0 0 0 calc(50% + 1.01px)' };
        setContainerHeight(`${height}px`);
      } else if (mediaFiles.length === 3) {
        height = 388;
        styles[0] = { inset: '0 0 calc(33.3333% + 1.01px)' };
        styles[1] = { inset: 'calc(66.6667% + 1.01px) calc(50% + 1.01px) 0 0' };
        styles[2] = { inset: 'calc(66.6667% + 1.01px) 0 0 calc(50% + 1.01px)' };
        setContainerHeight(`${height}px`);
      } else if (mediaFiles.length >= 4) {
        height = 388;
        styles[0] = { inset: '0 0 calc(33.3333% + 1.01px)' };
        styles[1] = {
          inset: 'calc(66.6667% + 1.01px) calc(66.6667% + 1.01px) 0 0'
        };
        styles[2] = {
          inset: 'calc(66.6667% + 1.01px) calc(33.3333% + 1.01px) 0'
        };
        styles[3] = {
          inset: 'calc(66.6667% + 1.01px) 0 0 calc(66.6667% + 1.01px)'
        };
        setContainerHeight(`${height}px`);
      }

      setImageStyles(styles);
    }
  }, [mediaFiles, cropList, containerWidth]);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <div className="w-100 m-2">
      <Card className="w-100">
        <div className="d-flex justify-content-between p-2 px-3">
          <div className="d-flex flex-row align-items-center">
            <div className="w-50px h-50px">
              <OnImagesLoaded
                onLoaded={() => {}}
                placeholder={<PlatformIconSkeleton />}
              >
                <Image src={platformIcon} className="img-fluid w-100 h-100" />
              </OnImagesLoaded>
            </div>
            <div className="d-flex flex-column align-items-start ms-2">
              <span className="fw-bolder">{profileName}</span>
              <span>
                <small>Followers</small>
              </span>
              <div className="d-flex flex-row align-items-center">
                <div className="d-flex align-items-center">
                  <small className="text-black-50">
                    {t('lomavisCreator.previewCards.just_now')}
                  </small>
                </div>
                <div className="ms-2">
                  <div className="d-flex align-items-center"></div>
                  <span>
                    <small>
                      <FontAwesomeIcon
                        className="me-2 text-black-50"
                        icon={faGlobeAmericas}
                      />
                    </small>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <FontAwesomeIcon className="me-2" icon={faEllipsis} />
          </div>
        </div>

        <div className="px-2 previewCardText d-flex align-items-start">
          <p className="py-2">
            {postText && (
              <span
                className="preview-text"
                style={{
                  color: 'black',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word'
                }}
                dangerouslySetInnerHTML={{ __html: postText }}
              />
            )}
          </p>
        </div>
        <div className="w-100">
          {mediaFiles.length === 0 && (
            <LinkPreview
              data={previewUrl}
              text={postText}
              platform={platform}
            />
          )}
        </div>

        {mediaFiles &&
          created_in_lomavis &&
          mediaFiles.filter(
            (item) =>
              item.type === 'image' ||
              item.type === 'video' ||
              item.type === 'doc'
          ).length > 0 && (
            <div
              className="asset_wrapper overflow-hidden"
              style={{
                maxHeight:
                  previewMode == PREVIEW_TYPE_COMPACT
                    ? COMPACT_MODE_HEIGHT
                    : '100%'
              }}
            >
              {isImageLoaded && (
                <div
                  style={{ zIndex: 3 }}
                  className="d-flex gap-2 justify-content-center align-items-center position-absolute ms-auto me-3 mt-3 end-0"
                >
                  <div
                    className="viewButton btn btn-sm btn-bg-white border border-dark px-3"
                    style={{
                      zIndex: 3
                    }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => viewAssets()}
                  >
                    <i
                      style={{ padding: '0px' }}
                      className="fa-regular fa-eye text-dark"
                    ></i>
                  </div>

                  <AltTagButton platform={platform} />

                  {mediaFiles.filter(
                    (item) => item.type === 'image' || item.type === 'video'
                  ).length > 0 && (
                    <div
                      className="btn btn-sm btn-bg-white border border-dark cropEditBtn firstImageCropEditBtn"
                      style={{ zIndex: 3 }}
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-image-index="0"
                      data-crop-wrapper-id="facebookCropSlide"
                      data-platform="facebook"
                      onClick={() => previewAssets()}
                    >
                      <span className="loading-indicator spinner-border spinner-border-sm d-none"></span>
                      <span>{t('lomavisCreator.preview.edit')}</span>
                    </div>
                  )}
                </div>
              )}
              <OnImagesLoaded
                onLoaded={() => {
                  setIsImageLoaded(true);
                }}
                placeholder={<PreviewImagesSkeleton />}
              >
                <div className="w-100">
                  {mediaFiles &&
                    mediaFiles.length > 0 &&
                    mediaFiles?.[0]?.type === 'video' && (
                      <VideoComponent
                        posterUrl={mediaFiles[0]?.custom_thumbnail_url}
                        videoUrl={
                          mediaFiles?.[0]?.file || mediaFiles?.[0]?.video_url
                        }
                        styles={{
                          maxHeight:
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : '100%'
                        }}
                      />
                    )}

                  {mediaFiles &&
                    mediaFiles.length > 0 &&
                    mediaFiles?.[0]?.type === 'doc' && (
                      <div className="position-relative w-100">
                        <PdfComponent
                          url={
                            mediaFiles[0].assetBlob
                              ? mediaFiles[0].assetBlob
                              : mediaFiles[0].original_asset
                          }
                          previewMode={previewMode}
                        />
                      </div>
                    )}

                  {mediaFiles &&
                    mediaFiles.length > 0 &&
                    mediaFiles?.[0]?.type === 'image' && (
                      <div
                        className="position-relative"
                        ref={containerRef}
                        style={{
                          maxHeight:
                            previewMode == PREVIEW_TYPE_COMPACT
                              ? COMPACT_MODE_HEIGHT
                              : mediaFiles.length == 1
                              ? '100%'
                              : containerHeight,
                          height:
                            mediaFiles.length > 1 ? containerHeight : '100%'
                        }}
                      >
                        {mediaFiles.slice(0, 4).map((media, index) => (
                          <div
                            key={index}
                            className={`${
                              mediaFiles.length == 1 ? '' : 'position-absolute'
                            } ${
                              mediaFiles.length >= index + 1 ? '' : 'd-none'
                            } ${
                              mediaFiles.length == 1 &&
                              previewMode == PREVIEW_TYPE_COMPACT
                                ? 'd-flex justify-content-center'
                                : ''
                            }`}
                            style={imageStyles[index]}
                          >
                            <Image
                              className={`img-fluid ${
                                mediaFiles?.length > 1 ? 'w-100 h-100' : ''
                              }`}
                              style={{
                                objectFit: 'cover',
                                maxHeight:
                                  previewMode == PREVIEW_TYPE_COMPACT
                                    ? COMPACT_MODE_HEIGHT
                                    : '100%'
                              }}
                              src={media.image_url}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </OnImagesLoaded>
            </div>
          )}
        {mediaFiles && !created_in_lomavis && (
          <div
            className="asset_wrapper overflow-hidden"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <ImportedPostsMediaPreview
              platform={platform}
              mediaFiles={mediaFiles}
            />
          </div>
        )}

        <div className="d-flex flex-row justify-content-start px-2 pt-3 border-top align-items-center">
          <p className="me-2">
            <FontAwesomeIcon className="me-2" icon={faThumbsUp} />
            {t('lomavisCreator.previewCards.like')}
          </p>
          <p className="me-2">
            <FontAwesomeIcon className="me-2" icon={faComment} />
            {t('lomavisCreator.previewCards.comment')}
          </p>
          <p className="me-2">
            <FontAwesomeIcon className="me-2" icon={faShare} />
            {t('lomavisCreator.previewCards.share')}
          </p>
          <p className="me-2">
            <FontAwesomeIcon className="me-2" icon={faPaperPlane} />
            {t('lomavisCreator.previewCards.send')}
          </p>
        </div>
      </Card>
    </div>
  );
}
